import React, {useState} from "react";
import axios from "axios";
import {myInitHeader} from "../../services/API/ApiClient";
import {getSessionData} from "../../services/auth/AuthAPI";
import {Collapse, Flex, Input, List, Spin, Typography} from "antd";
import {SearchOutlined} from "@ant-design/icons";
import "./BulkSearchPage.css";

const {Panel} = Collapse;
const {Text} = Typography;
const COLLECTION_NAME = "brands_mirrored_structure";

const BulkSearchPage: React.FC = () => {
    const [query, setQuery] = useState("");
    const [results, setResults] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);

    const hostname = "https://api.search-optimization-poc.wl-dev-logostore.com";
    const apiKey = "776446faa0df4f74943b009bc9af4b11";
    const queryBy = "Name,StockSymbols.ISIN,StockSymbols.Symbol,Tags";
    const multi_search_limit = 400;
    let sort_by = "_text_match:desc";

    const handleSearch = async () => {
        const queries = query
            .split(/[;,\n\r]/)
            .map((q) => q.trim())
            .filter(Boolean);
        if (!queries.length) return;
        setLoading(true);
        try {
            const myNewInit = myInitHeader(await getSessionData());
            const response = await axios.post(`${hostname}/multi_search?query_by=${queryBy}&limit_multi_searches=${multi_search_limit}&sort_by=${sort_by}&prefix=true&prioritize_token_position=true`, {
                searches: queries.map((q: any) => ({
                    collection: COLLECTION_NAME,
                    q
                }))
            }, {headers: {"X-TYPESENSE-API-KEY": apiKey, "Content-Type": "application/json", ...myNewInit.headers}});
            setResults(response.data.results || []);
        } catch (error) {
            console.error("Error searching:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="d-flex flex-column h-100 align-items-center">
            <div className="d-flex content-container">
                <h3 className="text-center">Bulk Search</h3>
                <div className="search-container d-flex  gap-3">
                    <Input.TextArea
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        placeholder="Search by Brand Name, ISIN, Stock Symbol with Comma Separated Values"
                        allowClear
                        size="large"
                        autoSize={{minRows: 1, maxRows: 4}}
                        style={{width: "1300px"}}
                    />

                    <div className={"link d-flex justify-content-center align-items-center"}>
                        <SearchOutlined onClick={handleSearch}/>
                    </div>
                    <div
                        // className="button"
                        className="link d-flex justify-content-center align-items-center"
                        onClick={() => {
                            setQuery("");
                            setResults([]);
                        }}>
                        Clear
                    </div>
                </div>
                <br/>

                {loading ? (
                    <div style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        padding: 20,
                        justifyContent: "center",
                        alignItems: "center"
                    }}>
                        <Spin
                            size="large"
                            style={{margin: 10}}
                        />
                    </div>
                ) : (
                    <Flex
                        wrap
                        style={{overflow: "hidden", height: "100%", alignSelf: "start", width: "1300px"}}>
                        {!loading && results.length > 0 && (
                            <div
                                style={{
                                    overflowY: "auto",
                                    height: "100%",
                                    position: "relative",
                                    border: "1px solid #ddd",
                                    padding: "10px",
                                    borderRadius: "8px",
                                    marginLeft: 10,
                                }}>
                                <Collapse style={{width: "1200px"}}>
                                    {results.map((brandResult, index) => (
                                        <Panel
                                            header={brandResult.request_params.q}
                                            key={index}>
                                            {brandResult.hits.length > 0 ? (
                                                <div>
                                                    <List
                                                        bordered
                                                        dataSource={brandResult.hits}
                                                        renderItem={(item: any) => (
                                                            <List.Item>
                                                                <div>
                                                                    <Text style={{ fontSize: '18px' }} strong={true}>{item.document.Name}</Text>
                                                                    <br/>
                                                                    <Text strong>
                                                                        Stock Symbols - &nbsp;
                                                                    </Text>
                                                                    <Text>
                                                                        {item.document.StockSymbols.length > 0 ?
                                                                            item.document.StockSymbols
                                                                                .map((brand: any) => brand.Symbol)
                                                                                .filter((symbol: string) => symbol) // removes empty/undefined/null values
                                                                                .join(', ') : "N/A"
                                                                        }
                                                                    </Text>
                                                                    <br/>
                                                                    <Text strong>
                                                                        Tags - &nbsp;
                                                                    </Text>
                                                                    <Text>
                                                                        {item.document.Tags.length > 0 ?
                                                                            item.document.Tags
                                                                                .join(', ') : "N/A"
                                                                        }
                                                                    </Text>
                                                                    <br/>
                                                                    <Text strong>
                                                                        ISIN - &nbsp;
                                                                    </Text>
                                                                    <Text>
                                                                        {item.document.StockSymbols.length > 0 ?
                                                                            item.document.StockSymbols
                                                                                .map((brand: any) => brand.ISIN)
                                                                                .filter((isin: string) => isin) // removes empty/undefined/null values
                                                                                .join(', ') : "N/A"
                                                                        }
                                                                    </Text>
                                                                </div>
                                                            </List.Item>
                                                        )}
                                                    />
                                                </div>
                                            ) : (
                                                <Text type="secondary">No results found.</Text>
                                            )}
                                        </Panel>
                                    ))}
                                </Collapse>
                            </div>
                        )}
                    </Flex>
                )}
            </div>
        </div>
    );
};

export default BulkSearchPage;
